import { CommandType } from '../../models/command-response';
import {NotificationPayload} from '../../models/notification-payload';
import {PanelOutputGroup} from '../../models/panel-output-group';
import {PanelOutput} from '../../models/panel-output.interface';

export class LoadUserPanelOutputs {
  static readonly type = '[Outputs] Load User Outputs';
}

export class SearchUserPanelOutputs {
  static readonly type = '[Outputs] Search User Devices';
  constructor(public readonly payload: string) { }
}

export class SelectPanelOutput {
  static readonly type = '[Outputs] Select Panel Output';
  constructor(public readonly payload: PanelOutput) { }
}


export class SelectPanelOutputGroup {
  static readonly type = '[Outputs] Select Panel Output Group';
  constructor(public readonly payload: PanelOutputGroup) { }
}

export class ClosePanelOutputs {
  static readonly type = '[Outputs] Close Panel Outputs';
  constructor(public readonly payload: PanelOutput[]) { }
}

export class OpenMomentOutputs {
  static readonly type = '[Outputs] Open Moment Panel Outputs';
  constructor(public readonly payload: PanelOutput[]) { }
}

export class OpenPermanentOutputs {
  static readonly type = '[Outputs] Open Permanent Panel Outputs';
  constructor(public readonly payload: PanelOutput[]) { }
}

export class ClosePanelOutputGroup {
  static readonly type = '[Outputs] Close Panel Output Group';
  constructor(public readonly payload: PanelOutputGroup) { }
}

export class OpenMomentOutputGroup {
  static readonly type = '[Outputs] Open Moment Panel Output Group';
  constructor(public readonly payload: PanelOutputGroup) { }
}

export class OpenPermanentOutputGroup {
  static readonly type = '[Outputs] Open Permanent Panel Output Group';
  constructor(public readonly payload: PanelOutputGroup) { }
}


export class SetCommandPending {
  static readonly type = '[Outputs] Set Command Pending';
  constructor(public readonly commandType: CommandType) { }
}

export class SetCommandError {
  static readonly type = '[Outputs] Set Command Error';
  constructor(public readonly commandType: CommandType) { }
}

export class SetCommandFailure {
  static readonly type = '[Outputs] Set Command Failure';
  constructor(public readonly commandType: CommandType) { }
}

export class SetCommandSuccess {
  static readonly type = '[Outputs] Set Command Success';
  constructor(public readonly commandType: CommandType) { }
}

export class ResetCommandsMessages {
  static readonly type = '[Outputs] Reset Actions Messages';
}

export class ChangePanelOutputsStatus {
  static readonly type = '[Outputs] Change Panel Outputs Status';
  constructor(public readonly payload: NotificationPayload) { }
}




export type PanelOutputsActions =
  LoadUserPanelOutputs |
  SearchUserPanelOutputs |
  SelectPanelOutput |
  SelectPanelOutputGroup |
  ClosePanelOutputs |
  OpenMomentOutputs |
  OpenPermanentOutputs;


